import Vue from "vue";
import parent from "../advertising";

export default {
    url({ advertisingId, path = "" }) {
        if (!advertisingId) throw Error("Undefined parent id");

        return `${parent.url()}/${advertisingId}/preview${path}`;
    },

    async start({ advertisingId }) {
        const url = this.url({ advertisingId, path: "/start" });

        return await Vue.http.get(url);
    },

    async next({ advertisingId, interactionId, optionId }) {
        const url = this.url({ advertisingId, path: `/${interactionId}` });

        return await Vue.http.post(url, {
            valor: optionId,
        });
    },
};
